export const categories = [
  {
    slug: "entertainment",
    name: "娱乐热议",
    desc: "综艺、舞台与圈内动态的投稿整理",
    icon: "ri-fire-line",
    longDesc:
      "从节目录制现场的观众投稿，到宣传期团队的行程变动，娱乐热议栏目聚焦可被公开讨论的行业动态。我们更关心「流程是怎样的」和「说法为什么不同」，而不是谁对谁错。",
  },
  {
    slug: "influencer",
    name: "网红动态",
    desc: "博主、直播间与内容账号的变动追踪",
    icon: "ri-user-voice-line",
    longDesc:
      "带货节奏、橱窗变动、账号停更，网红动态栏目收集创作者端与品牌端的双向投稿，用时间线的方式还原一次合作是怎样开始、又为什么结束。",
  },
  {
    slug: "screens",
    name: "影视综料",
    desc: "剧集电影与综艺幕后的公开线索",
    icon: "ri-movie-2-line",
    longDesc:
      "路透造型、片场花絮、宣传期互动，影视综料栏目只收录已经在公开渠道出现过的素材，并对拍摄现场与成片之间的差异做客观标注。",
  },
  {
    slug: "society",
    name: "社会观察",
    desc: "社区、公共空间与日常生活的围观记录",
    icon: "ri-community-line",
    longDesc:
      "电梯广告、景区预约、社区沟通，社会观察栏目关注那些与普通人生活直接相关的小切口事件，鼓励投稿人提供完整的沟通过程而非单一截图。",
  },
  {
    slug: "brand",
    name: "品牌公关",
    desc: "新品、联名与营销动作的舆情整理",
    icon: "ri-store-3-line",
    longDesc:
      "上新、联名、补货与售后，品牌公关栏目把消费者的投稿反馈按时间顺序排好，帮助读者看清一次营销活动在真实用户端究竟发生了什么。",
  },
  {
    slug: "picks",
    name: "投稿精选",
    desc: "编辑部逐条梳理的本周高价值线索",
    icon: "ri-star-smile-line",
    longDesc:
      "投稿精选栏目由编辑部从海量来稿中挑出信息密度最高的线索，补充背景与核对结论，适合想快速了解全貌的读者。",
  },
];